import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Dialog, Typography, Button } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'

export type ModalInfoProps = {
  title?: string,
  isVisible: boolean,
  description?: string,
  buttonText?: string,
  onClick?: () => void,
  onClose?: () => void,
  width?: number,
  height?: number
}

const useStyles = makeStyles({
  container: {
    flex: 1,
    width: 400,
    height: 400,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: mutualTheme.spacing(3),
    [mutualTheme.breakpoints.down('md')]: {
      width: 300,
      height: 300
    }
  },
  title: {
    flexGrow: 1,
    display: 'flex',
    fontWeight: 'bold',
    marginBottom: mutualTheme.spacing(2)
  },
  content: {
    flexGrow: 1,
    textAlign: 'center',
    display: 'flex',
    marginBottom: mutualTheme.spacing(2)
  },
  button: {
    width: '50%',
    borderRadius: 5,
    textTransform: 'none',
    height: mutualTheme.spacing(6)
  },
  linkBox: {
    marginTop: mutualTheme.spacing(3)
  },
  buttonText: {
    fontWeight: 700
  }
})

export const Modal: React.FC<ModalInfoProps> = (props) => {
  const { isVisible, onClick, title, description, buttonText } = props
  const classes = useStyles()

  return (
    <Dialog open={isVisible} maxWidth='md'>
      <>
        <Typography className={classes.title} variant='h5' align='center'>{title}</Typography>
        <Typography className={classes.content}>{description}</Typography>
        {(onClick && buttonText) && (
          <Button
            size='large'
            color='primary'
            onClick={onClick}
            variant='contained'
            className={classes.button}
          >
            <Typography className={classes.buttonText}>
              {buttonText}
            </Typography>
          </Button>
        )}
      </>
    </Dialog>
  )
}
